<template>
    <div class="w-full lg:w-1/3 h-full flex flex-col papsi-sidebar px-20 py-10">
        <!-- <div class="flex justify-center">
            <img class="pt-5 w-2/3" :src="getImage('logo')" />
        </div> -->

        <div class="flex flex-row justify-center align-center items-center mt-5" style="gap: 1rem;">
            <img class="logo" style="width: 7rem;" src="https://resource.pafcpic.net/assets/ga/papsi_icon.png" />
            <img class="logo shadow-lg" style="width: 10rem;" :src="getImage('pia-4')"/>
        </div>
    
        <div class="flex flex-1 justify-start items-center papsi-text">
            <div class="flex flex-col">
                    <div class="relative bubble-wrapper">
                        <div class="bg-white rounded-3xl p-10 relative shadow-lg bubble-shine">
                            <slot></slot>
                        </div>
                        <div class="bubble-pointer"></div>
                    </div>
                </div>
               
        </div>
    </div>
</template>
  
<script>
import mixin from '@/mixins/controls.js';

export default {
    name: 'v-sidebar',
    mixins: [mixin],
    
  };
</script>
  
<style scoped>
    .papsi-sidebar {
        /* background-image: url('https://resource.pafcpic.net/assets/pia/images/elements/papsi_bg.webp'); */
        /* background-image: url('@/assets/images/papsi-sidebar.png'); */
        background-image: url('https://resource.pafcpic.net/assets/pia/images/elements/papsi-sidebar.png');
        background-size: cover;
        background-position: center;
    }

    .papsi-text{
        padding-bottom: 16rem;
        /* animation: pop 0.5s ease-out; */
    }

    @keyframes pop {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.15);
        }
        100% {
            transform: scale(1);
        }
        }
</style>
  